import { useTranslation } from '@shared/localization';
import { BiX } from 'react-icons/bi';

import PaymentStore from '@/services/payments/PaymentStore';
import TelemetryService from '@/services/telemetry/TelemetryService';
import { redirect } from '@/utils/redirect';

import { SimpleButton } from '../../../common';

interface CancelPaymentButtonProps {
  readonly className?: string;
}

export function CancelPaymentButton({ className }: CancelPaymentButtonProps) {
  const { t } = useTranslation();

  const url = PaymentStore.cancelUrl;

  if (url === undefined) {
    return null;
  }
  return (
    <>
      <BiX className="text-2xl" />
      <SimpleButton
        onClick={() => {
          TelemetryService.trackEvent({
            name: 'CancelPaymentBtn',
            properties: {
              pid: PaymentStore.paymentIntentId,
              flow: PaymentStore.flow,
            },
          });
          redirect(url);
        }}
        className={className}
      >
        {t('Cancel payment')}
      </SimpleButton>
    </>
  );
}
